(() => {
  const LIMIT = 6;

  // 画面内の数量inputを合計（カート/ドロワー/通知に対応）
  function totalQty() {
    const inputs = document.querySelectorAll(
      'input[name="updates[]"], input.quantity__input, input[name="quantity"]'
    );
    let total = 0;
    inputs.forEach((el) => {
      const v = parseInt(el.value, 10);
      if (!isNaN(v)) total += v;
    });
    return total;
  }

  function setCheckoutDisabled(disabled) {
    // checkoutボタン（カート/ドロワー/通知）
    const buttons = document.querySelectorAll(
      'button[name="checkout"], #checkout, #CartDrawer-Checkout'
    );
    buttons.forEach((btn) => {
      if (disabled) {
        btn.setAttribute('disabled', 'disabled'); // ← CSSより強い
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
      }
    });

    // 追加のダイナミックチェックアウト（Shop Pay等）も「見えない」ようにする
    const dynamicAreas = document.querySelectorAll(
      '.additional-checkout-buttons, [data-shopify-buttoncontainer]'
    );
    dynamicAreas.forEach((area) => {
      area.style.display = disabled ? 'none' : '';
    });

    // 既存の警告があるなら表示切替（idが無ければ無視される）
    const warning = document.getElementById('qty-limit-warning');
    if (warning) warning.style.display = disabled ? '' : 'none';
  }

  function apply() {
    setCheckoutDisabled(totalQty() > LIMIT);
  }

  // 数量変更（+/- や直接入力）後に再判定
  document.addEventListener('click', (e) => {
    if (e.target.closest('.quantity__button') || e.target.closest('button[name="plus"]') || e.target.closest('button[name="minus"]')) {
      setTimeout(apply, 150);
    }
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name="updates[]"], input.quantity__input, input[name="quantity"]')) {
      setTimeout(apply, 80);
    }
  });

  // ここが最重要：仮にボタンが押せても「送信そのもの」を止める
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form && (form.id === 'cart' || form.id === 'CartDrawer-Form' || form.id === 'cart-notification-form' || form.matches('form[action*="/cart"]'))) {
      if (totalQty() > LIMIT) {
        e.preventDefault();
        e.stopPropagation();
        apply();
        alert('合計6本までご購入可能です。数量を調整してください。');
      }
    }
  }, true);

  window.addEventListener('load', apply);

  // テーマがAJAXでDOM差し替えしても追従
  const mo = new MutationObserver(() => apply());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();